import React, { useEffect, useRef } from 'react'
import { useParams } from 'react-router-dom'

import { CheckoutForm } from '@components'
import { PubSubService, StripeProvider } from '@services'
import { useCashRegister, usePubSubEvents } from '@hooks'
import { PUBSUB_GROUP_EVENT } from '@common'
import { storageHelpers } from '@utils'

const PAYMENT_TIMEOUT = 120 * 1000

const PaymentScreen = () => {
    const { clientSecret } = useParams()
    const paymentTimer = useRef(null)
    const { joinedGroupName } = useCashRegister()
    const isPaymentCompleted = useRef(false)
    const isPaymentCancelled = useRef(false)
    const isFirstRender = useRef(true)

    usePubSubEvents({
        events: [PUBSUB_GROUP_EVENT.PAYMENT_CANCEL],
        handlers: {
            [PUBSUB_GROUP_EVENT.PAYMENT_CANCEL]: () => {
                const paymentOrigin = storageHelpers.getPaymentOrigin()

                if (paymentOrigin === 'checkout-assistant') {
                    isPaymentCancelled.current = true
                    const stripeFrame = document.querySelector('iframe[name^="__privateStripeFrame"]')
                    if (stripeFrame?.parentElement) {
                        stripeFrame.parentElement.remove()
                    }

                    PubSubService.sendToGroup(joinedGroupName, { type: PUBSUB_GROUP_EVENT.PAYMENT_CANCEL })
                    window.history.go(-1)
                }
            },
        },
    })

    useEffect(() => {
        // const currentUrl = window.location.href
        // window.history.pushState({ fromPayment: true }, '', currentUrl)

        const preventNavigation = async () => {
            window.removeEventListener('popstate', preventNavigation)

            const stripeFrame = document.querySelector('iframe[name^="__privateStripeFrame"]')
            if (stripeFrame?.parentElement) {
                stripeFrame.parentElement.remove()
            }

            // PubSubService.sendToGroup(joinedGroupName, { type: PUBSUB_GROUP_EVENT.PAYMENT_FAILED })
            window.history.go(-1)
        }

        window.addEventListener('popstate', preventNavigation)

        return () => {
            window.removeEventListener('popstate', preventNavigation)
        }
    }, [])

    useEffect(() => {
        paymentTimer.current = setTimeout(() => {
            const stripeFrame = document.querySelector('iframe[name^="__privateStripeFrame"]')
            if (stripeFrame?.parentElement) {
                stripeFrame.parentElement.remove()
            }

            const paymentOrigin = storageHelpers.getPaymentOrigin()
            if (paymentOrigin === 'checkout-assistant') {
                PubSubService.sendToGroup(joinedGroupName, { type: PUBSUB_GROUP_EVENT.PAYMENT_FAILED })
            }
            window.history.go(-1)
        }, PAYMENT_TIMEOUT)

        return () => clearTimeout(paymentTimer.current)
    }, [])

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false
            return
        }

        return () => {
            const paymentOrigin = storageHelpers.getPaymentOrigin()

            if (!isPaymentCompleted.current && !isPaymentCancelled.current && paymentOrigin === 'checkout-assistant') {
                PubSubService.sendToGroup(joinedGroupName, {
                    type: PUBSUB_GROUP_EVENT.PAYMENT_FAILED,
                })
            }
        }
    }, [])

    const appearance = {
        theme: 'stripe',
    }

    const options = {
        clientSecret,
        appearance,
    }

    return (
        <div>
            {clientSecret && (
                <StripeProvider options={options}>
                    <CheckoutForm clientSecret={clientSecret} />
                </StripeProvider>
            )}
        </div>
    )
}

export default PaymentScreen
